import React from "react";

import classNames from "classnames";
import isEmpty from "lodash.isempty";
import { observer } from "mobx-react";
import pluralize from "pluralize";
import PropTypes from "prop-types";

import JobCardWithTitle from "../../../components/JobCardWithTitle/JobCardWithTitle";
import GridVacancyDescriptiveItem from "./GridVacancyDescriptiveItem";
import GridVacancyDescriptiveItemReordered from "./GridVacancyDescriptiveItemReordered";
import GridVacancyItem from "./GridVacancyItem";
import NoVacancies from "./NoVacancies";
import ReadMoreItem from "./ReadMoreItem";
import ThumbnailItem from "./ThumbnailItem";

const cardType = {
  JobCardWithTitle,
  default: GridVacancyItem,
  gridWithHeaderFilter: GridVacancyDescriptiveItem,
  readMoreItem: ReadMoreItem,
  withThumbnail: ThumbnailItem,
  descriptiveItemReordered: GridVacancyDescriptiveItemReordered,
};

function GridVacancyList(props) {
  const {
    displayVancanciesCount = true,
    searchResults,
    resultsCount,
    isLoading,
    type,
  } = props;

  if (isEmpty(searchResults)) {
    return <NoVacancies />;
  }

  const JobCardComponent = cardType[type] || cardType.default;

  const backgroundClassNames = classNames("row ", {
    "g-4": type !== "JobCardWithTitle",
    "gy-5 gx-2": type === "JobCardWithTitle",
  });

  const cardClassNames = classNames("col-md-4 col-lg-4", {
    "col-12 col-md-12 col-lg-12": type === "readMoreItem", // This will apply col-12 to all breakpoints when type is ReadMoreItem
    "col-lg-3": type === "JobCardWithTitle",
  });

  return (
    <>
      {displayVancanciesCount ? (
        <h2>{pluralize("JOB", resultsCount, displayVancanciesCount)} FOUND</h2>
      ) : null}
      <div className={backgroundClassNames}>
        {searchResults.map((vacancy) => (
          <div key={vacancy.vacancyId} className={cardClassNames}>
            <JobCardComponent
              isLoading={isLoading}
              showLocation={type === "JobCardWithTitle"}
              vacancy={vacancy}
            />
          </div>
        ))}
      </div>
    </>
  );
}

export default observer(GridVacancyList);

GridVacancyList.propTypes = {
  displayVancanciesCount: PropTypes.bool,
  isLoading: PropTypes.bool,
  resultsCount: PropTypes.number.isRequired,
  searchResults: PropTypes.arrayOf(
    PropTypes.shape({
      vacancyId: PropTypes.string.isRequired,
    })
  ),
  type: PropTypes.string,
};

GridVacancyList.defaultProps = {
  displayVancanciesCount: true,
  isLoading: false,
  searchResults: [],
  type: "default",
};
